import React from "react";
import { LuMessageSquare as MessageSquare } from "react-icons/lu";
import { PostWithUser } from "../../types/index.type";

import { PostCard } from "./post-card";

type PostsTableProps = {
  data: PostWithUser[];
};

// Main PostsTable Component
export const PostsTable = ({ data }: PostsTableProps) => {
  console.log(data);

  if (data.length === 0) {
    return (
      <div className="text-center py-16">
        <MessageSquare className="h-12 w-12 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">No posts found</h3>
        <p className="text-gray-500">When posts are available, they'll appear here.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {data.map(({ post, user }) => (
        <PostCard key={post.id} post={post} user={user} />
      ))}
    </div>
  );
};

// import {
//   LuTrash2 as Trash2,
//   LuEye as Eye,
//   LuClock as Clock,
//   LuActivity as Activity,
//   LuBrain as Brain,
//   LuMessageSquare as MessageSquare,
//   LuPaperclip as Paperclip,
// } from "react-icons/lu";
// import { Card, CardContent, CardHeader, CardTitle } from "./post-card";
// import { Badge } from "src/components/Badge/Badge";
// import { useDeletePostByIdMutation } from "../../post.service";
// import { useAppDispatch } from "src/store";
// import { showToast } from "src/store/toast.store";
// import { Link } from "react-router-dom";
// import { PostWithUser } from "../../types/index.type";
// import {
//   getPostTypeBadgeClasses,
//   getPostTypeIcon,
//   getUserRoleBadgeClasses,
//   getVibeIcon,
//   getVisibilityBadgeClasses,
//   getVisibilityIcon,
// } from "../../utils/posts-style";
// import { getTimeAgo } from "src/utils/date.util";

// type PostsTableProps = {
//   data: PostWithUser[];
// };

// export const PostsTable = ({ data }: PostsTableProps) => {
//   console.log(data);
//   const dispatch = useAppDispatch();
//   const [deletePost] = useDeletePostByIdMutation();

//   const handleDelete = async (postId: string) => {
//     try {
//       await deletePost(postId);
//       dispatch(
//         showToast({
//           type: "success",
//           message: "Post deleted successfully",
//         })
//       );
//     } catch (error) {
//       dispatch(
//         showToast({
//           type: "error",
//           message: "Failed to delete the post",
//         })
//       );
//     }
//   };

//   const getTotalVibes = (vibeCounts: Record<string, number>) => {
//     return Object.values(vibeCounts).reduce((sum, count) => sum + count, 0);
//   };

//   if (data.length === 0) {
//     return (
//       <div className="text-center py-16">
//         <MessageSquare className="h-12 w-12 text-gray-300 mx-auto mb-4" />
//         <h3 className="text-lg font-medium text-gray-900 mb-2">No posts found</h3>
//         <p className="text-gray-500">When posts are available, they'll appear here.</p>
//       </div>
//     );
//   }

//   return (
//     <div className="space-y-6">
//       {data.map(({ post, user }) => (
//         <Card
//           key={post.id}
//           className="group relative overflow-hidden border-0 shadow-sm hover:shadow-lg transition-all duration-300 bg-white/50 backdrop-blur-sm"
//         >
//           {/* Subtle gradient border effect */}
//           <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 via-purple-500/10 to-pink-500/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

//           <CardHeader className="relative pb-4">
//             <div className="flex items-start justify-between">
//               <div className="flex-1 space-y-3">
//                 {/* User Info Row */}
//                 <div className="flex items-center gap-3">
//                   <div className="flex items-center gap-2">
//                     {user ? (
//                       <>
//                         <img
//                           src={user.pictureURL || "https://via.placeholder.com/32x32?text=U"}
//                           alt={user.name}
//                           className="w-8 h-8 rounded-full object-cover border-2 transition-colors duration-300
//                           border-gray-200"
//                         />
//                         <CardTitle className="text-lg font-semibold text-gray-900">{user.name}</CardTitle>
//                       </>
//                     ) : (
//                       <>
//                         <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-sm font-semibold">
//                           {post.userId.charAt(0).toUpperCase()}
//                         </div>
//                         <CardTitle className="text-lg font-semibold text-gray-900">{post.userId}</CardTitle>
//                       </>
//                     )}
//                   </div>
//                   <Badge
//                     classes={`${getUserRoleBadgeClasses(post.role)} font-medium px-2.5 py-1 rounded-full text-xs`}
//                     label={post.role}
//                   />
//                 </div>

//                 {/* Post Meta Row */}
//                 <div className="flex items-center gap-4 text-sm">
//                   <div className="flex items-center gap-2">
//                     <div className="flex items-center gap-1.5">
//                       {getPostTypeIcon(post.type)}
//                       <Badge
//                         classes={`${getPostTypeBadgeClasses(post.type)} font-medium px-2.5 py-1 rounded-full text-xs`}
//                         label={post.type.replace("_", " ")}
//                       />
//                     </div>

//                     <div className="flex items-center gap-1.5">
//                       {getVisibilityIcon(post.visibility)}
//                       <Badge
//                         classes={`${getVisibilityBadgeClasses(
//                           post.visibility
//                         )} font-medium px-2.5 py-1 rounded-full text-xs`}
//                         label={post.visibility}
//                       />
//                     </div>
//                   </div>

//                   <div className="flex items-center gap-4 text-gray-500">
//                     <div className="flex items-center gap-1.5">
//                       <Clock className="h-4 w-4" />
//                       <span className="font-medium">{getTimeAgo(post.createdAt)}</span>
//                     </div>
//                     <div className="px-2 py-1 bg-gray-100 rounded-full text-xs font-semibold text-gray-600">
//                       {post.langCode.toUpperCase()}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Action Buttons */}
//               <div className="flex items-center gap-2 opacity-80 group-hover:opacity-100 transition-opacity">
//                 <Link
//                   to={`/users/${user?.id}`}
//                   className="inline-flex items-center justify-center gap-2 px-4 py-2.5
//                      rounded-xl text-sm font-semibold text-blue-600
//                      bg-blue-50 border border-blue-100
//                      hover:bg-blue-100 hover:text-blue-700 hover:border-blue-200
//                      active:bg-blue-200 transition-all duration-200
//                      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2
//                      disabled:pointer-events-none disabled:opacity-50 no-underline
//                      hover:shadow-md hover:-translate-y-0.5"
//                 >
//                   <Eye className="h-4 w-4" />
//                   View user
//                 </Link>
//                 <button
//                   className={`inline-flex items-center justify-center gap-2 px-4 py-2.5
//                      rounded-xl text-sm font-semibold text-red-600
//                      bg-red-50 border border-red-100
//                      hover:bg-red-100 hover:text-red-700 hover:border-red-200
//                      active:bg-red-200 transition-all duration-200
//                      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-400 focus-visible:ring-offset-2
//                      disabled:pointer-events-none disabled:opacity-50
//                      hover:shadow-md hover:-translate-y-0.5
//                      cursor-pointer
//                      `}
//                   onClick={() => handleDelete(post.id)}
//                 >
//                   <Trash2 />
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </CardHeader>

//           <CardContent className="relative space-y-5">
//             {/* Post Content */}
//             <div className="prose prose-sm max-w-none">
//               <p className="text-gray-700 leading-relaxed">{post.content}</p>
//             </div>

//             {/* Activity Stats */}
//             {post.type === "ACTIVITY" && (
//               <div className="bg-gradient-to-r from-purple-50/80 to-blue-50/80 p-4 rounded-xl border border-purple-100">
//                 <div className="flex items-center gap-2 mb-3">
//                   <Activity className="h-5 w-5 text-purple-600" />
//                   <h4 className="font-semibold text-purple-900">Activity Stats</h4>
//                 </div>
//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                   <div className="bg-white/70 rounded-lg p-3 border border-purple-100">
//                     <div className="text-xs text-purple-600 font-medium mb-1">Scheduled Meetings</div>
//                     <div className="text-lg font-bold text-purple-900">{post.activity.scheduledMinutes} min</div>
//                   </div>
//                   <div className="bg-white/70 rounded-lg p-3 border border-blue-100">
//                     <div className="text-xs text-blue-600 font-medium mb-1">Direct Calls</div>
//                     <div className="text-lg font-bold text-blue-900">{post.activity.directCallMinutes} min</div>
//                   </div>
//                   {post.activity.aiLearningMinutes ? (
//                     <div className="bg-white/70 rounded-lg p-3 border border-emerald-100">
//                       <div className="text-xs text-emerald-600 font-medium mb-1">AI Learning</div>
//                       <div className="text-lg font-bold text-emerald-900">{post.activity.aiLearningMinutes} min</div>
//                     </div>
//                   ) : null}
//                 </div>
//               </div>
//             )}

//             {/* Duo Thought */}
//             {post.type === "DUO_THOUGHT" && (
//               <div className="bg-gradient-to-r from-amber-50/80 to-orange-50/80 p-4 rounded-xl border border-amber-100">
//                 <div className="flex items-center gap-2 mb-3">
//                   <Brain className="h-5 w-5 text-amber-600" />
//                   <h4 className="font-semibold text-amber-900">Duo Thought</h4>
//                 </div>
//                 <div className="bg-white/70 rounded-lg p-3 border border-amber-100">
//                   <div className="flex items-center gap-2">
//                     <div className="w-6 h-6 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center text-white text-xs font-semibold">
//                       {post.partner.userId.charAt(0).toUpperCase()}
//                     </div>
//                     <div>
//                       <div className="text-xs text-amber-600 font-medium">Collaboration Partner</div>
//                       <div className="font-semibold text-amber-900">{post.partner.userId}</div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Attachments */}
//             {post.attachments && post.attachments.length > 0 && (
//               <div className="space-y-3">
//                 <div className="flex items-center gap-2">
//                   <Paperclip className="h-4 w-4 text-gray-500" />
//                   <h4 className="font-semibold text-gray-900">Attachments ({post.attachments.length})</h4>
//                 </div>
//                 <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//                   {post.attachments.map((attachment, index) => (
//                     <div
//                       key={index}
//                       className="group relative overflow-hidden rounded-xl border border-gray-200 hover:border-gray-300 transition-colors"
//                     >
//                       {attachment.fileType === "IMAGE" ? (
//                         <img
//                           src={attachment.fileUrl}
//                           alt={`Attachment ${index + 1}`}
//                           className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300"
//                         />
//                       ) : attachment.fileType === "VIDEO" ? (
//                         <video
//                           src={attachment.fileUrl}
//                           className="w-full h-32 object-cover rounded-lg"
//                           controls
//                           preload="metadata"
//                         />
//                       ) : null}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}

//             {/* Reactions */}
//             <div className="flex items-center justify-between pt-4 border-t border-gray-100">
//               <div className="flex items-center gap-1">
//                 <span className="text-sm font-medium text-gray-600">{getTotalVibes(post.vibeCounts)} reactions</span>
//               </div>

//               <div className="flex items-center gap-1">
//                 {Object.entries(post.vibeCounts).map(
//                   ([type, count]) =>
//                     count > 0 && (
//                       <div
//                         key={type}
//                         className="group flex items-center gap-1.5 px-2 py-1 bg-gray-50 hover:bg-gray-100 rounded-full transition-colors"
//                       >
//                         {getVibeIcon(type)}
//                         <span className="text-sm font-medium text-gray-700">{count}</span>
//                       </div>
//                     )
//                 )}
//               </div>
//             </div>
//           </CardContent>
//         </Card>
//       ))}
//     </div>
//   );
// };
